// SCR-STAFF-502 — مواجهه (US-CLN-010 تا 012، 020 تا 025، 030، 040): همان فضای کار میز کار در صفحه مستقل /desk/encounters/:id (پیوند خط زمانی
// و کارهای معوق).
import Stack from '@mui/material/Stack';
import { useTranslation } from '@phoenix/i18n';
import { PageHeader } from '@phoenix/ui';
import { useParams } from 'react-router';
import { SCR_STAFF_502 } from './common';
import { EncounterWorkspace } from './EncounterWorkspace';

export function EncounterPage() {
  useTranslation('cln');
  const { id } = useParams();
  return (
    <Stack spacing={2} data-screen-id={SCR_STAFF_502}>
      <PageHeader titleKey="cln:encounter.title" />
      {id ? <EncounterWorkspace encounterId={id} /> : null}
    </Stack>
  );
}
